import { render, staticRenderFns } from "./SamTechIndicator.vue?vue&type=template&id=59a958a5&scoped=true&"
import script from "./SamTechIndicator.vue?vue&type=script&lang=js&"
export * from "./SamTechIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a958a5",
  null
  
)

export default component.exports